import { createStackedState, StackedStateCleanUp } from "client/Misc/stackedState";
import create, { UseStore } from "zustand";
import createVanilla, { StoreApi } from "zustand/vanilla";

type BackNavigationCallback = () => void;

export type TitleBarNavigationStoreData = {
	backNavigationCallback: BackNavigationCallback | undefined;
	isBackButtonAvailable: boolean;
	setBackNavigationCallback: (
		backNavigationCallback: BackNavigationCallback
	) => StackedStateCleanUp;
	setIsBackButtonAvailable(isVisible: boolean): void;
	restoreState(): void;
};

export const titleBarNavigationStore: StoreApi<TitleBarNavigationStoreData> = createVanilla(
	set => {
		return {
			isBackButtonAvailable: false,
			backNavigationCallback: undefined,
			setBackNavigationCallback: createStackedState<BackNavigationCallback>(
				(backNavigationCallback: BackNavigationCallback | undefined) => set({ backNavigationCallback })
			),
			setIsBackButtonAvailable: isBackButtonAvailable => set({ isBackButtonAvailable }),
			restoreState: () => set({
				isBackButtonAvailable: false,
				backNavigationCallback: undefined,
			})
		};
	}
);

export const useTitleBarNavigationStore: UseStore<TitleBarNavigationStoreData> = create(titleBarNavigationStore);